import PaymentMethodsService from "@/services/PaymentMethodsService";
import { replaceItemInList, removeItemFromList } from "@/utils/listHelpers";
import { notifyStoreError } from "@/utils/storeHelpers";
const errorMessages = {
    list: 'Erro ao buscar os métodos de pagamento. Tente novamente.',
    create: 'Erro ao adicionar o método de pagamento. Tente novamente.',
    update: 'Erro ao atualizar o método de pagamento. Tente novamente.',
    delete: 'Erro ao excluir o método de pagamento. Tente novamente.',
};
export default {
    namespaced: true,
    state: {
        paymentMethodsData: [],
        status: null,
    },
    getters: {
        getPaymentMethodsData: (state) => {
            if (Array.isArray(state.paymentMethodsData))
                return state.paymentMethodsData;
            if (state.paymentMethodsData && state.paymentMethodsData.data)
                return state.paymentMethodsData.data;
            return [];
        },
        getStatus: (state) => state.status,
    },
    mutations: {
        setPaymentMethodsData(state, data) {
            state.paymentMethodsData = data;
        },
        setStatus(state, status) {
            state.status = status;
        },
        createPaymentMethodInList(state, paymentMethod) {
            if (!paymentMethod)
                return;
            if (Array.isArray(state.paymentMethodsData)) {
                state.paymentMethodsData.push(paymentMethod);
            }
            else if (state.paymentMethodsData?.data && Array.isArray(state.paymentMethodsData.data)) {
                state.paymentMethodsData.data.push(paymentMethod);
            }
        },
    },
    actions: {
        async getPaymentMethods({ commit, dispatch }, payload) {
            try {
                const response = await PaymentMethodsService.getPaymentMethods(payload.data, payload.userToken);
                commit('setPaymentMethodsData', response.data);
            }
            catch (error) {
                commit('setStatus', errorMessages.list);
                notifyStoreError(dispatch, errorMessages.list, error);
            }
            finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true });
                }
            }
        },
        async createPaymentMethod({ commit, dispatch }, payload) {
            try {
                const response = await PaymentMethodsService.createPaymentMethod(payload.data, payload.userToken);
                commit('createPaymentMethodInList', response.data);
                dispatch('toastfy/activeSuccesNotification', { text: 'Método de pagamento adicionado com sucesso' }, { root: true });
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.create, error);
            }
        },
        async updatePaymentMethod({ commit, state, dispatch }, payload) {
            try {
                const response = await PaymentMethodsService.updatePaymentMethod(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Método de pagamento atualizado com sucesso' }, { root: true });
                commit('setPaymentMethodsData', replaceItemInList(state.paymentMethodsData, response.data));
                return response.data;
            }
            catch (error) {
                return notifyStoreError(dispatch, errorMessages.update, error);
            }
        },
        async deletePaymentMethod({ commit, state, dispatch }, payload) {
            try {
                await PaymentMethodsService.deletePaymentMethod(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Método de pagamento deletado com sucesso' }, { root: true });
                commit('setPaymentMethodsData', removeItemFromList(state.paymentMethodsData, payload.data));
            }
            catch (error) {
                notifyStoreError(dispatch, errorMessages.delete, error);
            }
        },
    }
};
